import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-home',
  templateUrl: './modal-home.component.html',
  styleUrl: './modal-home.component.scss'
})
export class ModalHomeComponent {

  constructor(
    private dialogRef: MatDialogRef<ModalHomeComponent>,
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
